import { LOG_OUT } from '../../redux/types';

const logOutAction = () => dispatch => {
  return dispatch({
    type: LOG_OUT,
  });
};

export default logOutAction;
